export default __webpack_public_path__ + "static/media/celestial-dragons.7bc43107.jpeg";